import { useApplicationStore } from "@versatile-credit-apply/sdk"
import type { RouteComponent, RouteMeta, RouteRecordRaw } from "vue-router"

type Decision =
  | "prequalified"
  | "nooffer"
  | "approved"
  | "declined"
  | "pending"
  | "error"

function createDecisionRoute(
  name: Decision,
  component: RouteComponent,
  meta?: RouteMeta
): RouteRecordRaw {
  return {
    name: `koalafi-apply-${name}`,
    path: name,
    component,
    meta,
  }
}

export const KoalafiDecisionRoutes: RouteRecordRaw[] = [
  createDecisionRoute(
    "prequalified",
    () => import("./components/KoalafiPrequalified.vue"),
    {
      next: "../application",
      step: "applicant",
    }
  ),
  createDecisionRoute(
    "nooffer",
    () => import("./components/KoalafiNoOffer.vue")
  ),
  createDecisionRoute(
    "approved",
    () => import("./components/KoalafiApproved.vue")
  ),
  createDecisionRoute(
    "declined",
    () => import("./components/KoalafiDeclined.vue")
  ),
  createDecisionRoute(
    "pending",
    () => import("./components/KoalafiPending.vue")
  ),
  createDecisionRoute("error", () => import("./components/KoalafiError.vue")),
]

export const KoalafiApplyRoutes: RouteRecordRaw[] = [
  {
    name: "koalafi-apply-routes",
    path: "koalafi_standard",
    children: [
      {
        name: "koalafi-start",
        path: "start/:mode",
        component: () => import("./pages/KoalafiIntroPage.vue"),
      },
      {
        name: "koalafi-terms",
        path: "terms",
        component: () => import("./pages/KoalafiTermsPage.vue"),
        meta: {
          next: () => {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "accept-offer" : "submit"
          },
          step: "terms",
        },
      },
      {
        name: "koalafi-apply-decisions",
        path: "decision",
        component: () => import("./pages/KoalafiDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: [...KoalafiDecisionRoutes],
      },
    ],
  },
]
